import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { FssTable } from "./FssTable";
import { useSelector, useDispatch } from "react-redux";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchAll,
} from "./fssSlice";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { getValueOptions } from "../../utility";

export const FssPage = () => {
  const dispatch = useDispatch();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);

  // Filter
  const [invoiceNo, setInvoiceNo] = useState("");
  const [clientName, setClientName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [retNumber, setRetNumber] = useState("");
  const [typeReturn, setTypeReturn] = useState("");

  const { id } = useParams();

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
  }, [dispatch]);

  useEffect(() => {
    if (id != null) {
      dispatch(
        fetchAll({
          stepCode: "SALES",
          retNumber: id,
          pageNo: pageNo,
          pageSize: pageSize,
        })
      );
    }
  }, [id]);

  const handleSearch = () => {
    const params = {
      stepCode: "SALES",
      invoiceNo: invoiceNo,
      clientName: clientName,
      customerName: customerName,
      retNumber: retNumber.replace(/\s/g, ""),
      typeReturn: typeReturn,
      pageNo: 1,
      pageSize: 10,
    };
    dispatch(fetchAll(params));
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    const params = {
      stepCode: "SALES",
      invoiceNo: invoiceNo,
      clientName: clientName,
      customerName: customerName,
      retNumber: retNumber.replace(/\s/g, ""),
      typeReturn: typeReturn,

      pageNo: page,
      pageSize: sizePerPage,
    };
    dispatch(fetchAll(params));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const typeReturnOptions = [
    { value: "", label: "All" },
    { value: "MTKA", label: "With RTV" },
    { value: "NON MTKA", label: "Without RTV" },
  ];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="FSS / ASM / BM"></CardHeader>
      <CardBody>
        {/* Filter */}
        <Form>
          <Form.Group as={Row}>
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>APL Return Number </b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="APL Return Number "
                    onChange={(e) => {
                      setRetNumber(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={retNumber}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Invoice Ref Number</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Invoice Ref Number"
                    onChange={(e) => {
                      setInvoiceNo(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={invoiceNo}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Type Return</b>
                </Form.Label>
                <Col sm={5}>
                  <Select
                    options={typeReturnOptions}
                    value={getValueOptions(typeReturn, typeReturnOptions)}
                    // placeholder="Select ..."
                    onChange={(e) => {
                      setTypeReturn(e.value);
                    }}
                    onKeyPress={handleKeyPress}
                  />
                </Col>
              </Form.Group>
            </Col>
            {/* Right Row */}
            <Col sm={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Customer Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Customer Name"
                    onChange={(e) => {
                      setCustomerName(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={customerName}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Row}>
                <Form.Label column sm={3}>
                  <b>Client Name</b>
                </Form.Label>
                <Col sm={5}>
                  <Form.Control
                    type="text"
                    placeholder="Client Name"
                    onChange={(e) => {
                      setClientName(e.target.value);
                    }}
                    onKeyPress={handleKeyPress}
                    value={clientName}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Button className="btn btn-primary" onClick={handleSearch}>
                  Search
                </Button>
              </Col>
            </Form.Group>
          </Form.Group>
        </Form>

        {/* Table */}
        {data && data.length > 0 && (
          <FssTable
            data={data}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        )}
      </CardBody>
    </Card>
  );
};
